import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "aios_cookie_consent"; // "granted" | "denied"

function updateConsent(granted) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const v = granted ? "granted" : "denied";
  window.gtag("consent", "update", {
    ad_storage: v,
    ad_user_data: v,
    ad_personalization: v,
    analytics_storage: v,
  });
}

// Banner de cookies (RGPD). El tag de Google Ads/Analytics arranca DENEGADO
// (Consent Mode v2 en index.html); solo se activa si el usuario acepta.
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (stored === "granted") {
      updateConsent(true); // usuario ya aceptó en visitas anteriores
    } else if (!stored) {
      setVisible(true); // primera visita: pedir consentimiento
    }
  }, []);

  const decide = (granted) => {
    localStorage.setItem(KEY, granted ? "granted" : "denied");
    updateConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] p-3 sm:p-4">
      <div className="max-w-4xl mx-auto border border-[var(--border)] bg-[var(--surface)] p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 shadow-2xl">
        <p className="text-xs sm:text-sm text-[var(--text-dim)] flex-1 leading-relaxed">
          Usamos cookies técnicas necesarias y, si lo aceptas, cookies de medición y publicidad (Google Ads)
          para saber qué anuncios funcionan. Puedes cambiar tu elección cuando quieras.{" "}
          <Link to="/cookies" className="text-[var(--accent)] hover:underline">Más información</Link>.
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => decide(false)}
            className="px-4 py-2 text-xs font-semibold border border-[var(--border)] text-[var(--text-dim)] hover:text-white hover:border-[var(--accent)]"
            data-testid="cookie-reject"
          >
            Rechazar
          </button>
          <button
            onClick={() => decide(true)}
            className="px-4 py-2 text-xs font-semibold"
            style={{ background: "var(--accent)", color: "var(--bg)" }}
            data-testid="cookie-accept"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
